"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldShowComparisonLine = exports.isHistoricalOrMarkBasedComparison = exports.isHistoricalComparisonSpec = exports.isNoComparison = exports.isMarkBasedComparison = exports.isStaticComparison = void 0;
function isStaticComparison(spec) {
    return spec.type === 'STATIC_COMPARISON';
}
exports.isStaticComparison = isStaticComparison;
function isMarkBasedComparison(spec) {
    return spec.type === 'MARK_BASED_COMPARISON';
}
exports.isMarkBasedComparison = isMarkBasedComparison;
var isNoComparison = function (spec) {
    return spec.type === 'NO_COMPARISON';
};
exports.isNoComparison = isNoComparison;
function isHistoricalComparisonSpec(spec) {
    return spec.type === 'HISTORICAL_COMPARISON';
}
exports.isHistoricalComparisonSpec = isHistoricalComparisonSpec;
function isHistoricalOrMarkBasedComparison(spec) {
    return isHistoricalComparisonSpec(spec) || isMarkBasedComparison(spec);
}
exports.isHistoricalOrMarkBasedComparison = isHistoricalOrMarkBasedComparison;
var shouldShowComparisonLine = function (comparison) {
    var _a;
    if (comparison === null) {
        return false;
    }
    if (isHistoricalComparisonSpec(comparison)) {
        return (_a = comparison.showComparisonLine) !== null && _a !== void 0 ? _a : false;
    }
    if (isMarkBasedComparison(comparison)) {
        return false;
    }
    if (isStaticComparison(comparison)) {
        return true;
    }
    return false;
};
exports.shouldShowComparisonLine = shouldShowComparisonLine;
//# sourceMappingURL=ComparisonSpecType.js.map